// Options
export const DOWNLOAD_OPTIONS = {
	INCLUDE_TOPICS:               "topics",
	NO_FORMAT:                    "no_format",
	INCLUDE_NOTES:                "notes",
	INCLUDE_HIGHLIGHTS:           "highlights",
	INCLUDE_SOURCES:              "sources",
	INCLUDE_CITATIONS:            "citations",
	INCLUDE_UNAPPROVED_CITATIONS: "unapproved_citations",
	INCLUDE_COMMENTS:             "comments",
	INCLUDE_ANNOTATION_TYPES:     "annotation_types"
};

// Format options - names match API query format parameter
export const SUBFORMATS_WORD = {
	OUTLINE:      "word",
	BIBLIOGRAPHY: "bibliography"
};

const SUBFORMAT_OPTIONS_WORD = {
	[SUBFORMATS_WORD.OUTLINE]: {
		label:   "Outline",
		options: Object.values(DOWNLOAD_OPTIONS)
	},
	[SUBFORMATS_WORD.BIBLIOGRAPHY]: {
		label:   "Bibliography",
		options: [
			DOWNLOAD_OPTIONS.INCLUDE_TOPICS,
			DOWNLOAD_OPTIONS.INCLUDE_UNAPPROVED_CITATIONS
		]
	}
};

export const SUBFORMATS_EXCEL = {
	TOPIC_SOURCE:   "topic-source",
	SOURCE_TOPIC:   "source-topic",
	SOURCE_SUMMARY: "source-summary",
	SOURCE_NOTES:   "source-notes",
	RESEARCH_LOG:   "research-log"
};

const SUBFORMAT_OPTIONS_EXCEL = {
	[SUBFORMATS_EXCEL.TOPIC_SOURCE]: {
		label:   "Topic - Source",
		options: [
			DOWNLOAD_OPTIONS.INCLUDE_TOPICS,
			DOWNLOAD_OPTIONS.INCLUDE_NOTES,
			DOWNLOAD_OPTIONS.INCLUDE_HIGHLIGHTS
		]
	},
	[SUBFORMATS_EXCEL.SOURCE_TOPIC]: {
		label:   "Source - Topic",
		options: [
			DOWNLOAD_OPTIONS.INCLUDE_TOPICS,
			DOWNLOAD_OPTIONS.INCLUDE_NOTES,
			DOWNLOAD_OPTIONS.INCLUDE_HIGHLIGHTS
		]
	},
	[SUBFORMATS_EXCEL.SOURCE_SUMMARY]: {
		label:   "Source Report",
		options: [
			DOWNLOAD_OPTIONS.INCLUDE_TOPICS,
			DOWNLOAD_OPTIONS.INCLUDE_UNAPPROVED_CITATIONS
		]
	},
	[SUBFORMATS_EXCEL.SOURCE_NOTES]: {
		label:   "Source Notes",
		value:   "source-notes",
		options: [
			DOWNLOAD_OPTIONS.INCLUDE_TOPICS
		]
	},
	[SUBFORMATS_EXCEL.RESEARCH_LOG]: {
		label:   "Research Log",
		value:   "research-log",
		options: [
			DOWNLOAD_OPTIONS.INCLUDE_TOPICS,
			DOWNLOAD_OPTIONS.INCLUDE_NOTES,
			DOWNLOAD_OPTIONS.INCLUDE_HIGHLIGHTS,
			DOWNLOAD_OPTIONS.INCLUDE_UNAPPROVED_CITATIONS
		]
	}
};

// File formats - names match API endpoints
export const FILE_FORMATS = {
	WORD:    "outline",
	EXCEL:   "spreadsheet",
	SOURCES: "citations"
};

// Select menu options
export const FILE_FORMAT_OPTIONS = {
	[FILE_FORMATS.WORD]: {
		label:      "Word (.docx)",
		subFormats: SUBFORMAT_OPTIONS_WORD
	},
	[FILE_FORMATS.EXCEL]: {
		label:      "Excel (.xlsx)",
		subFormats: SUBFORMAT_OPTIONS_EXCEL
	},
	[FILE_FORMATS.SOURCES]: {
		label:   "Sources (.ris)",
		options: [
			DOWNLOAD_OPTIONS.INCLUDE_TOPICS,
			DOWNLOAD_OPTIONS.INCLUDE_UNAPPROVED_CITATIONS
		]
	}
};
